import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Rightpart.css";
import faviconImg from "../../assets/images/favicon.png";
import ordersdetail from "../assets/images/order-detail.png";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'; 
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { fetchUserAppAPI } from '../../utils/api';

export default function ManageRight() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  // Form states
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/login");
      return;
    }
    
    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);
    fetchProfile(parsedUser.user_id);
  }, [navigate]);

  const fetchProfile = async (userId) => {
    try {
      const response = await fetchUserAppAPI("getprofile", {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
      });

      if (response && response.status === 200 && response.result) {
        const p = response.result;
        setFirstName(p.user_first_name || "");
        setLastName(p.user_last_name || "");
        setEmail(p.user_email || "");
        setPhone(p.user_mobile || "");
        setGender(p.user_gender || "");
        setDob(p.user_dob || "");
        setImagePreview(p.user_profile_image || "");
        
        // Update local storage user just in case
        localStorage.setItem("user", JSON.stringify(p));
        setUser(p);
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    if (!user) return;

    setLoading(true);
    setMessage("");
    setError("");

    try {
      const formData = new FormData();
      formData.append("user_id", user.user_id);
      formData.append("user_first_name", firstName);
      formData.append("user_last_name", lastName);
      formData.append("user_email", email);
      formData.append("user_gender", gender);
      formData.append("user_dob", dob);
      if (imageFile) {
        formData.append("user_profile_image", imageFile);
      }

      const response = await fetchUserAppAPI("updateprofile", {
        method: "POST",
        body: formData,
      });

      if (response && response.status === 200) {
        setMessage(response.msg || "Profile updated successfully.");
        // Fetch new profile information to update states
        fetchProfile(user.user_id);
      } else {
        setError(response.msg || "Failed to update profile.");
      }
    } catch (err) {
      setError("An error occurred while saving the profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='order-detail-main-outer'>
      <div className='order-detail-content'>
         
         <div className='outer-box-oc'>
               <div className='row'>
                  <div className="col-12">
                     <div className="profile_section_user">
                        <div className="img_user_profile_sec">
                           <img 
                             src={imagePreview || faviconImg} 
                             alt="user profile" 
                             style={{ objectFit: 'cover', borderRadius: '50%' }} 
                             onError={(e) => {
                               e.target.onerror = null;
                               e.target.src = faviconImg;
                             }}
                           />
                        </div>
                        <div className="info_profile_sec">
                          <h4>{firstName} {lastName}</h4>
                          <div className="user_more_info_sec">
                            <ul>
                               <li><LocalPhoneOutlinedIcon/> {phone}</li>
                               <li><EmailOutlinedIcon/> {email || "No email added"}</li>
                               <li>
                                 <LocationOnOutlinedIcon/> {
                                   (() => {
                                     const raw = user?.user_created || user?.created_at || user?.user_created_at || user?.user_date || user?.created;
                                     if (!raw) return "Member";
                                     try {
                                       const d = new Date(raw);
                                       if (isNaN(d.getTime())) return raw;
                                       return `Since ${d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}`;
                                     } catch (e) {
                                       return raw;
                                     }
                                   })()
                                 }
                               </li>
                            </ul>
                          </div>
                        </div>
                     </div>
                  </div>

                  <div className='col-lg-12 col-12 mb-4'>
                      <div className='address-manager'>
                        <div className='box-top'>
                          <div className='sr-number'>
                              <h4>Edit Profile Information</h4>
                          </div> 
                        </div>
                        <div className='billing-text'>
                          {message && <div className="alert alert-success py-2">{message}</div>}
                          {error && <div className="alert alert-danger py-2">{error}</div>}

                          <form onSubmit={handleSaveProfile}>
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                  <label className="form-label small fw-bold">First Name</label>
                                  <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder="First Name" 
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    required
                                    disabled={loading}
                                  />
                              </div> 
                              <div className="col-md-6 mb-3">
                                  <label className="form-label small fw-bold">Last Name</label>
                                  <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder="Last Name" 
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    required
                                    disabled={loading}
                                  />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6 mb-3">
                                  <label className="form-label small fw-bold">Email Address</label>
                                  <input 
                                    type="email" 
                                    className="form-control" 
                                    placeholder="Email Address" 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={loading}
                                  />
                              </div>
                              <div className="col-md-6 mb-3">
                                  <label className="form-label small fw-bold">Phone Number (Read-only)</label>
                                  <input 
                                    type="tel" 
                                    className="form-control" 
                                    placeholder="Phone Number" 
                                    value={phone}
                                    disabled 
                                  />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6 mb-3">
                                  <label className="form-label small fw-bold">Gender</label>
                                  <select 
                                    className="form-control" 
                                    value={gender}
                                    onChange={(e) => setGender(e.target.value)}
                                    disabled={loading}
                                  >
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                  </select>
                              </div>
                              <div className="col-md-6 mb-3">
                                  <label className="form-label small fw-bold">Date of Birth</label>
                                  <input 
                                    type="date" 
                                    className="form-control" 
                                    value={dob}
                                    onChange={(e) => setDob(e.target.value)}
                                    disabled={loading}
                                  />
                              </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label small fw-bold">Profile Image</label>
                                <input 
                                  type="file" 
                                  className="form-control" 
                                  accept="image/*"
                                  onChange={handleImageChange}
                                  disabled={loading}
                                />
                            </div>

                            <div className="d-flex justify-content-end">
                                <button type="submit" className="btn btn-success px-4" disabled={loading}>
                                    {loading ? "Saving..." : "Save Profile"}
                                </button>
                            </div>
                          </form>
                        </div>
                      </div>
                  </div>
              </div>
         </div>
      </div>
    </div>
  );
}
